// extracted by mini-css-extract-plugin
module.exports = {"comp":"PowerBackup_comp__l_53t"};